import Login from "../views/Login.svelte";
import Home from "../views/Home.svelte";
import AsList from "../views/AsList.svelte";
import AsDtl from "../views/AsDtl.svelte";
import AsForm from "../views/AsForm.svelte";
import AsRM from "../views/AsRM.svelte";
import AsItem from "../views/AsItem.svelte";
import AsHistoryList from "../views/AsHistoryList.svelte";
import AsItemForm from "../views/AsItemForm.svelte";
import InspectList from "../views/InspectList.svelte";
import InspectDtl from "../views/InspectDtl.svelte";
import NotFound from "../views/NotFound.svelte";
import Temp from "../views/Temp.svelte";

export default {
    "/": Login,
    "/Login": Login,
    "/Home": Home,
    "/AsList": AsList,
    "/InspectList": InspectList,
    "/InspectDtl/:bplc_code/:plan_no/:plan_sn/:qltinsp_se": InspectDtl,
    "/AsDtl/:rcept_NO/:rcept_SN": AsDtl,
    "/AsForm/:rcept_NO/:rcept_SN/:photo_SE": AsForm,
    "/AsRM/:rcept_NO/:rcept_SN/:sttus_nm/:bcnc_NM": AsRM,
    "/AsItem/:rcept_NO/:rcept_SN": AsItem,
    "/AsHistoryList/:bcnc_CODE/:page": AsHistoryList,
    "/AsItemForm/:rcept_NO/:rcept_SN": AsItemForm,
    "/Temp": Temp,
    "*": NotFound,
};
